module.exports = __webpack_public_path__ + "static/saumyakaran-animoji-b0a561f993e9db326d40b8e902f860c7.png";